/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
//import { observer } from 'mobx-react';
import Chart from 'chart.js/auto';
import './MiniPieChart.css';

class MiniPieChart extends Component {
  constructor(props) {
    super(props);
    this.chart = null;
    this.state = {
      chartData: props.chartData,
    };
  }

  componentDidMount() {
    this.drawChart();
  }

  componentDidUpdate(prevProps) {
    const { chartData } = this.props;

    if (chartData && prevProps.chartData.total !== chartData.total) {
      this.drawChart();
    }
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  abbreviateNumber(value) {
    let newValue = value;
    if (value >= 10000) {
      const suffixes = ['', 'K', 'M', 'B', 'T'];
      const suffixNum = Math.floor(` ${value}`.length / 4);
      let shortValue = '';
      let i = 4; //precision
      for (i; i >= 1; i--) {
        shortValue = parseFloat(
          (suffixNum !== 0 ? value / (1000 ** suffixNum) : value).toPrecision(i) // prettier-ignore
        ); // ** : Math.pow()
        const dotLessShortValue = `${shortValue} `.replace(/[^a-zA-Z 0-9]+/g, '');
        if (dotLessShortValue.length <= 4) {
          break;
        }
      }
      //if (shortValue % 1 !== 0) {
      //const shortNum = shortValue.toFixed(1);
      //console.log(shortNum);
      //}
      newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
  }

  drawChart() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }

    const { translate } = this.props;
    const { chartData } = this.state;

    const config = {
      type: 'pie',
      data: {
        datasets: [
          {
            label: [translate('chart.title.risk'), translate('chart.title.safety')],
            data: [chartData.has_risk, chartData.total - chartData.has_risk],
            backgroundColor: ['#FF7D00', '#8A6FEB'],
            borderWidth: 0,
          },
        ],
      },
      options: {
        plugins: {
          tooltip: {
            enabled: false,
          },
          legend: {
            display: false,
          },
        }
        //maintainAspectRatio: false,
        //responsive: true,
      },
    };

    const ctx = this.pieChart.getContext('2d');
    this.chart = new Chart(ctx, config);
  }

  render() {
    const { translate } = this.props;

    return (
      <div className="mini_pie_chart_wrap">
        <div className="mini_pie_chart_value">
          <p className="label">{translate('chart.title.total')}</p>
          {
            this.props.chartData.total !== 0 ? (
              <p className="value">
                {this.abbreviateNumber(this.props.chartData.total)}
              </p>
            ) : (
              <p className="value disable">
                {this.abbreviateNumber(this.props.chartData.total)}
              </p>
            )
          }
        </div>
        <div className="mini_pie_chart">
          {
            this.props.chartData.total !== 0 ? (
              <span className="value">
                {this.abbreviateNumber(this.props.chartData.has_risk)}
              </span>
            ) : (
              <span className="value disable">
                {this.abbreviateNumber(this.props.chartData.has_risk)}
              </span>
            )
          }
          <canvas
            ref={(ref) => { this.pieChart = ref; }}
          />
        </div>
      </div>
    );
  }
}

export default MiniPieChart;
